import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePage from './pages/home';
import RequestLoginOtpPage from './pages/auth/requestLoginOtp';
import VerifyLoginOtpPage from './pages/auth/verifyLoginOtp';
import SignUpPage from './pages/auth/signUp';
import ProfilePage from './pages/protected/profile';
import RideIdlePage from './pages/protected/ride/idle';
import RideBookingInitializedPage from './pages/protected/ride/bookingInitialized';
import RideBookingQueuedPage from './pages/protected/ride/bookingQueued';
import RideInRidePage from './pages/protected/ride/inRide';
import RideCompletedPage from './pages/protected/ride/completed';
import PrivacyPolicyPage from './pages/privacyPolicy';
import ContactUsPage from './pages/contactUs';
import RequestDataDeletionPage from './pages/requestDataDeletion';
import RequestAccountDeletionPage from './pages/requestAccountDeletion';
import AuthContextProvider, { AuthContext } from './context/AuthContextProvider';
import AppStateContextProvider, { AppStateContext } from './context/AppStateContextProvider';

import { useEffect, useState } from 'react';
import { SafeArea } from '@capacitor-community/safe-area';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import VerifySignUpOtpPage from './pages/auth/verifySignUpOtp';

export default function App() {
    const [insets, setInsets] = useState({ top: 0, bottom: 0 });

    useEffect(() => {
        async function setup() {
            if (!Capacitor.isNativePlatform()) return;

            // fix status bar
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setStyle({ style: Style.Default });

            // get REAL device insets from native layer
            const result = await SafeArea.getSafeAreaInsets();
            setInsets(result.insets);
        }

        setup();
    }, []);

    return (
        <div
            style={{
                paddingTop: insets.top,
                paddingBottom: insets.bottom,
                height: '100vh',
                boxSizing: 'border-box',
            }}
        >
            <AuthContextProvider>
                <AppStateContextProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                            <Route path="/contact-us" element={<ContactUsPage />} />
                            <Route
                                path="/users/request-data-deletion"
                                element={<RequestDataDeletionPage />}
                            />
                            <Route
                                path="/users/request-account-deletion"
                                element={<RequestAccountDeletionPage />}
                            />

                            <Route path="/auth/sign-up" element={<SignUpPage />} />
                            <Route
                                path="/auth/request-login-otp"
                                element={<RequestLoginOtpPage />}
                            />
                            <Route path="/auth/verify-login-otp" element={<VerifyLoginOtpPage />} />
                            <Route
                                path="/auth/verify-signup-otp"
                                element={<VerifySignUpOtpPage />}
                            />

                            <Route path="/protected/profile" element={<ProfilePage />} />

                            <Route path="/protected/ride/idle" element={<RideIdlePage />} />
                            <Route
                                path="/protected/ride/booking-initialized"
                                element={<RideBookingInitializedPage />}
                            />
                            <Route
                                path="/protected/ride/booking-queued"
                                element={<RideBookingQueuedPage />}
                            />
                            <Route path="/protected/ride/in-ride" element={<RideInRidePage />} />
                            <Route
                                path="/protected/ride/completed"
                                element={<RideCompletedPage />}
                            />

                            <Route path="*" element={<HomePage />} />
                        </Routes>
                    </BrowserRouter>
                </AppStateContextProvider>
            </AuthContextProvider>
        </div>
    );
}
